module.exports = __webpack_public_path__ + "static/media/201CS266.ece4b222.jpg";